export const theme = {
  gutter: 8,
  colors: {
    white: '#fff',
    blue10: 'rgba(233, 236, 244, 1)',
    blue60: 'rgba(35, 68, 141, 1)',
    blue80: 'rgba(6, 35, 95, 1)',
    blue100: 'rgba(0, 37, 62, 1)',
    gold40: 'rgba(224, 198, 142, 1)',
    gold60: 'rgba(194, 155, 64, 1)',
    gold80: 'rgba(166, 137, 64, 1)',
    gray10: 'rgba(249, 249, 249, 1)',
    gray20: 'rgba(241, 241, 241, 1)',
    gray30: 'rgba(231, 231, 231, 1)',
    gray40: 'rgba(217, 217, 217, 1)',
    gray50: 'rgba(206, 206, 206, 1)',
    gray70: 'rgba(143, 143, 143, 1)',
    gray80: 'rgba(107, 107, 107, 1)',
    gray90: 'rgba(51, 51, 51, 1)',
    gray100: 'rgba(41, 41, 41, 1)',
    red20: 'rgba(247, 201, 198, 1)',
    red60: 'rgba(221, 36, 21, 1)',
    green20: 'rgba(211, 231, 212, 1)',
    green60: 'rgba(79, 158, 83, 1)',
    orange20: 'rgba(252, 228, 191, 1)',
    navy100: 'rgba(0, 37, 62, 1)',
    navy20: 'rgba(195, 205, 211, 1)',
  },
  border: {
    color: 'rgba(217, 217, 217, 1)',
    radius: 2,
  },
  transition: {
    duration: '200ms',
    timing: 'ease-out',
  },
  font: {
    fontMercuryDisplay: 'Mercury Display',
    fontBentonSans: 'BentonSans',
    fontMulish: 'Mulish',
    sizeMin: 14,
    size: 18,
  },
  pageWidth: 1180,
  pageLimit: function pageLimit({ theme }: any): number {
    return theme.pageWidth + theme.breakpoints.lg.gutter * 2;
  },
  breakpoints: {
    sm: { width: 414, gutter: 32 }, //  mobile
    md: { width: 768, gutter: 50 }, //  tablet
    lg: { width: 1080, gutter: 70 }, // desktop
  },
};

export type DefaultTheme = typeof theme;
